import {APP_PREFIX_PATH} from "../AppConfig";
import React from "react";


export const mahasiswaDataRoutes = [
    {
        key: 'pages.krs.mahasiswa',
        path: `${APP_PREFIX_PATH}/mahasiswa/krs`,
        component: React.lazy(() => import('views/mahasiswa-views/mahasiswa-krs/ShowKrsMahasiswa')),
    },
    {
        key: 'pages.krs.mahasiswa.detail',
        path: `${APP_PREFIX_PATH}/mahasiswa/krs/detail/:id`,
        component: React.lazy(() =>import('views/mahasiswa-views/mahasiswa-krs/detail/DetailKrsMahasiswa')),
    },
    {
        key: 'pages.krs.mahasiswa.input',
        path: `${APP_PREFIX_PATH}/mahasiswa/krs/view`,
        component: React.lazy(() =>import('views/mahasiswa-views/mahasiswa-krs/view/ViewKrsMahasiswa')),
    },

    // message
    {
        key: 'mahasiswa.message',
        path: `${APP_PREFIX_PATH}/mahasiswa/message/*`,
        component: React.lazy(() => import('views/master-view/message')),
    },

    // payment
    {
        key: 'mahasiswa.payment',
        path: `${APP_PREFIX_PATH}/mahasiswa/payment`,
        component: React.lazy(() => import('views/mahasiswa-views/payment')),
    },
    {
        key: 'mahasiswa.payment.all',
        path: `${APP_PREFIX_PATH}/mahasiswa/payment/all`,
        component: React.lazy(() => import('views/mahasiswa-views/payment/all')),
    },
    {
        key: 'mahasiswa.payment.detail',
        path: `${APP_PREFIX_PATH}/mahasiswa/payment/detail/:id`,
        component: React.lazy(() => import('views/mahasiswa-views/payment/detail')),
    },
    {
        key: 'mahasiswa.payment.bayar',
        path: `${APP_PREFIX_PATH}/mahasiswa/payment/bayar`,
        component: React.lazy(() => import('views/mahasiswa-views/payment/bayar')),
    },
/*    {
        key: 'mahasiswa.payment.invoice',
        path: `${APP_PREFIX_PATH}/mahasiswa/payment/invoice/:id`,
        component: React.lazy(() => import('views/mahasiswa-views/payment/invoice')),
    },*/
    {
        key: 'mahasiswa.payment.invoice',
        path: `${APP_PREFIX_PATH}/mahasiswa/payment/invoice`,
        component: React.lazy(() => import('views/mahasiswa-views/payment/invoice')),
    },
    
    {
        key: 'mahasiswa.payment.upload',
        path: `${APP_PREFIX_PATH}/mahasiswa/payment/upload`,
        component: React.lazy(() => import('views/mahasiswa-views/payment/upload')),
    },
    {
        key: 'mahasiswa.payment.info',
        path: `${APP_PREFIX_PATH}/mahasiswa/payment/info/:id`,
        component: React.lazy(() => import('views/mahasiswa-views/payment/info')),
    },


    {
        key: 'mahasiswa.perkuliahan.history',
        path: `${APP_PREFIX_PATH}/mahasiswa/perkuliahan/history`,
        component: React.lazy(() => import('views/mahasiswa-views/perkuliahan/history')),
    },
    {
        key: 'mahasiswa.perkuliahan.history.aktifitas_perkuliahan',
        path: `${APP_PREFIX_PATH}/mahasiswa/perkuliahan/history/aktifitas_perkuliahan`,
        component: React.lazy(() => import('views/mahasiswa-views/perkuliahan/history/aktifitas_perkuiahan')),
    },
    {
        key: 'mahasiswa.perkuliahan.history.krs',
        path: `${APP_PREFIX_PATH}/mahasiswa/perkuliahan/history/krs`,
        component: React.lazy(() => import('views/mahasiswa-views/perkuliahan/history/krs')),
    },
    {
        key: 'mahasiswa.perkuliahan.history.nilai',
        path: `${APP_PREFIX_PATH}/mahasiswa/perkuliahan/history/nilai`,
        component: React.lazy(() => import('views/mahasiswa-views/perkuliahan/history/nilai')),
    },
    {
        key: 'mahasiswa.perkuliahan.history.transkip',
        path: `${APP_PREFIX_PATH}/mahasiswa/perkuliahan/history/transkip`,
        component: React.lazy(() => import('views/mahasiswa-views/perkuliahan/history/transkip')),
    },
    {
        key: 'mahasiswa.perkuliahan.ktm',
        path: `${APP_PREFIX_PATH}/mahasiswa/perkuliahan/ktm`,
        component: React.lazy(() => import('views/mahasiswa-views/perkuliahan/ktm')),
    },

    // SPADA
    {
        key: 'mahasiswa.perkuliahan.spada',
        path: `${APP_PREFIX_PATH}/mahasiswa/spada`,
        component: React.lazy(() => import('views/mahasiswa-views/spada')),
    },

    // ADMINISTRASI.SKRIPSI
    {
        key: 'mahasiswa.administrasi.skripsi',
        path: `${APP_PREFIX_PATH}/mahasiswa/administrasi/skripsi`,
        component: React.lazy(() => import('views/mahasiswa-views/administrasi/skripsi')),
    },
    {
        key: 'mahasiswa.administrasi.skripsi.seminar_proposal',
        path: `${APP_PREFIX_PATH}/mahasiswa/administrasi/skripsi/seminar_proposal`,
        component: React.lazy(() => import('views/mahasiswa-views/administrasi/skripsi/seminar_proposal')),
    },
    {
        key: 'mahasiswa.administrasi.skripsi.seminar_proposal.detail',
        path: `${APP_PREFIX_PATH}/mahasiswa/administrasi/skripsi/seminar_proposal/detail`,
        component: React.lazy(() => import('views/mahasiswa-views/administrasi/skripsi/seminar_proposal/detail')),
    },
    {
        key: 'mahasiswa.administrasi.skripsi.seminar_proposal.edit',
        path: `${APP_PREFIX_PATH}/mahasiswa/administrasi/skripsi/seminar_proposal/update`,
        component: React.lazy(() => import('views/mahasiswa-views/administrasi/skripsi/seminar_proposal/update')),
    },
    {
        key: 'mahasiswa.administrasi.skripsi.seminar_proposal.add',
        path: `${APP_PREFIX_PATH}/mahasiswa/administrasi/skripsi/seminar_proposal/add`,
        component: React.lazy(() => import('views/mahasiswa-views/administrasi/skripsi/seminar_proposal/add')),
    },



    {
        key: 'mahasiswa.administrasi.skripsi.seminar_hasil',
        path: `${APP_PREFIX_PATH}/mahasiswa/administrasi/skripsi/seminar_hasil`,
        component: React.lazy(() => import('views/mahasiswa-views/administrasi/skripsi/seminar_hasil')),
    },
    {
        key: 'mahasiswa.administrasi.skripsi.seminar_hasil.detail',
        path: `${APP_PREFIX_PATH}/mahasiswa/administrasi/skripsi/seminar_hasil/detail`,
        component: React.lazy(() => import('views/mahasiswa-views/administrasi/skripsi/seminar_hasil/detail')),
    },


    {
        key: 'mahasiswa.administrasi.skripsi.ujian_tutup',
        path: `${APP_PREFIX_PATH}/mahasiswa/administrasi/skripsi/ujian_tutup`,
        component: React.lazy(() => import('views/mahasiswa-views/administrasi/skripsi/ujian_tutup')),
    },
    {
        key: 'mahasiswa.administrasi.skripsi.ujian_tutup.detail',
        path: `${APP_PREFIX_PATH}/mahasiswa/administrasi/skripsi/ujian_tutup/detail`,
        component: React.lazy(() => import('views/mahasiswa-views/administrasi/skripsi/ujian_tutup/detail')),
    },

    {
        key: 'mahasiswa.administrasi.penangguhan',
        path: `${APP_PREFIX_PATH}/mahasiswa/penangguhan`,
        component: React.lazy(() => import('views/mahasiswa-views/administrasi/penangguhan')),
    },
    {
        key: 'mahasiswa.administrasi.penangguhan.pembayaran',
        path: `${APP_PREFIX_PATH}/mahasiswa/penangguhan/pembayaran`,
        component: React.lazy(() => import('views/mahasiswa-views/administrasi/penangguhan/pembayaran')),
    },
    {
        key: 'mahasiswa.administrasi.penangguhan.pembayaran.add',
        path: `${APP_PREFIX_PATH}/mahasiswa/penangguhan/pembayaran/add`,
        component: React.lazy(() => import('views/mahasiswa-views/administrasi/penangguhan/pembayaran/add')),
    },


    {
        key: 'mahasiswa.administrasi.wisuda',
        path: `${APP_PREFIX_PATH}/mahasiswa/administrasi/wisuda`,
        component: React.lazy(() => import('views/mahasiswa-views/administrasi/wisuda')),
    },
    {
        key: 'mahasiswa.administrasi.wisuda.detail',
        path: `${APP_PREFIX_PATH}/mahasiswa/administrasi/wisuda/detail`,
        component: React.lazy(() => import('views/mahasiswa-views/administrasi/wisuda/detail')),
    },
    

]
